const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Estensione dati Mobile Connect",
    cellModemIMEI: "Numero IMEI del modem cellulare",
    siteName: "Nome del sistema",
    siteAddress: "Indirizzo del sistema",
    cellPlanEndDate: "Data di fine del piano Cell Modem",
    daysToExpiry: "Giorni alla scadenza",
    currentPlanStatus: "Stato attuale del piano",
    gatewaySNo: "Gateway S.NO",
    paymentStatus: "Stato del pagamento",
    lastDateOfPurchase: "Ultima data di acquisto",
    extendDataPlan: "Estensione del piano dati",
    purchasedBy: "Acquistato da",
    purchasedFrom: "Acquistato da",
    siteId: "ID sistema",
    orderNo: "Numero d'ordine",
    footer: 'Estensione dati Mobile Connect',
    total: 'Totale',
    record: 'record',
    records: 'record',
    show: 'Mostra',
    enphase_store: 'Enphase Store',
    orderSummary: "Riepilogo dell'ordine.",
    confirmSelection: 'Confermare la selezione qui sotto',
    noOfCellModems: 'Numero di modem cellulari',
    years: 'Anni',
    pricePerSite: 'Prezzo per sito',
    cancel:'Annullamento',
    submit:'Invia',
    back: 'Indietro',
    noTokens: '** Nessun modem cellulare disponibile **',
    redirectToStoreText: 'Reindirizzamento al  Enphase  store ! Attendere prego...!',
    toolTipExtensionInfo: 'Solo i piani per modem cellulari a cui mancano meno di 180 giorni alla scadenza possono essere prorogati.',
    allCellModems: 'Tutti i modem cellulari',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Modem cellulari idonei',
    nonAdminInfo: "Contattare l'amministratore per estendere il piano dati per un modem cellulare.",
    select: 'Selezionare',
    typeToSearch: 'Digita per cercare',
    dataPlanExtensionSuccess: "L'estensione dati Mobile Connect è riuscita. Potrebbe essere necessario un po' di tempo prima che il pagamento venga visualizzato nella dashboard.",
    expired: 'Scaduto',
    active: 'Attivo',
    failed: "Pagamento non riuscito",
    pending: "Elaborazione del pagamento",
    success: "Pagamento riuscito",
  }
}

export default dataPlanExtension